var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "iconR-dashboard",
    x: 0.703,
    y: 0.131,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconR-dashboard1",
    serifid: "iconR-dashboard",
    d: "M23.685,14.416c-0,-5.674 -5.292,-10.28 -10.962,-10.299l-0.034,-0c-5.686,-0 -10.981,4.613 -10.981,10.299c0,1.888 0.61,3.716 1.399,5.061c-0,0 -0,0 -0,0c0.238,0.408 0.56,0.65 1.031,0.65l17.208,-0c0.471,-0 0.707,-0.276 0.948,-0.65c0.87,-1.35 1.391,-3.175 1.391,-5.061Zm-1.588,-0c-0,1.492 -0.381,2.848 -1.103,4.121c0,-0 -3.992,0 -8.058,0c-4.221,0 -8.521,0 -8.521,0c-0.73,-1.293 -1.119,-2.627 -1.119,-4.121c0,-4.801 4.591,-8.711 9.393,-8.711l0.034,-0c4.785,0.019 9.374,3.922 9.374,8.711Zm-3.874,-5.37c-0.305,-0.273 -0.809,-0.233 -1.092,0.119c0.001,-0.001 -3.544,3.596 -3.544,3.596c-0.267,-0.1 -0.582,-0.167 -0.883,-0.167c-1.367,0 -2.472,1.106 -2.472,2.472c0,1.366 1.105,2.471 2.472,2.471c1.366,0 2.471,-1.105 2.471,-2.471c-0,-0.486 -0.127,-0.895 -0.394,-1.282c-0,-0 3.558,-3.625 3.558,-3.625c0.272,-0.333 0.226,-0.833 -0.117,-1.113l0.001,0Zm-4.636,6.02c-0,0.486 -0.397,0.883 -0.883,0.883c-0.487,0 -0.884,-0.397 -0.884,-0.883c0,-0.484 0.399,-0.852 0.884,-0.852c0.484,-0 0.883,0.367 0.883,0.852Zm-7.288,-0.852c-0,-0.55 -0.448,-1 -1,-1c-0.552,-0 -1,0.45 -1,1c-0,0.55 0.448,1 1,1c0.552,-0 1,-0.448 1,-1Zm13.813,-1.102c-0.552,0 -1,0.448 -1,1c-0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1c-0,-0.552 -0.446,-1 -1,-1Zm-12.448,-4.328c-0.55,-0 -1,0.45 -1,1c-0,0.55 0.45,1 1,1c0.55,-0 1,-0.45 1,-1c-0,-0.55 -0.45,-1 -1,-1Zm5.04,-0.079c0.552,-0 1,-0.448 1,-1c-0,-0.552 -0.45,-1 -1,-1c-0.55,-0 -1,0.45 -1,1c-0,0.55 0.45,1 1,1Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRDashboard);
export default __webpack_public_path__ + "static/media/iconR-dashboard.70fa9eb979ea20cee14e8f9f09d82e23.svg";
export { ForwardRef as ReactComponent };